@if (populationRules) {
<header>
  <div class="title">
    @if (categoryRules?.id) {
    <span class="ui page-num circular label">{{ categoryRules?.pageNum }}</span>
    } @if (!categoryRules?.id) {
    <span class="globe-icon"></span>
    }
    {{ categoryRules?.name }}
    @if (userInfo.isAdmin) {
    <div
      class="ui toggle checkbox hiddenQuestionToggle"
      (click)="toggleHiddenQuestions()"
    >
      <input
        type="checkbox"
        name="showHiddenQuestions"
        [ngModel]="showHiddenQuestions"
      />
      <label>{{ "clients.show-hidden-questions" | transloco }}</label>
    </div>
    }
  </div>
  <div class="actions">
    <span id="count">{{ unsavedControls }}</span>
    {{ "clients.unsaved" | transloco }}
    @if (canEditClientRules()) {
    <div
      (click)="save()"
      id="save-btn"
      class="ui primary background button"
      [ngClass]="{ disabled: !unsavedControls || isSaving, loading: isSaving }"
    >
      {{ "clients.save" | transloco }}
    </div>
    }
  </div>
</header>
}

<div #rulesBody class="body hidden-scrollbar rules-boundary">
  <div id="questions">
    @for (question of categoryRules?.clientQuestions | orderBy: 'order'; track
    question) { @if (question.displayFieldType !== 'table' &&
    !question.parentId) {
    <div (click)="selectField(question)" id="{{ 'question-' + question.id }}">
      @if (question) {
      <app-form-field-wrapper
        [disabled]="
          (categoryRules?.id && hasGlobalAnswer(question)) ||
          (!categoryRules?.id && isUnassignedPopulation()) ||
          undefined
        "
        [visiblyDisabled]="
          (categoryRules?.id && hasGlobalAnswer(question)) ||
          (!categoryRules?.id && isUnassignedPopulation()) ||
          undefined
        "
        [setGlobal]="canEditClientRules() && setGlobal"
        [formGroup]="formGroup"
        [questions]="categoryRules?.clientQuestions"
        [question]="question"
        [showHiddenQuestion]="showHiddenQuestions"
        [isUnassignedPopulation]="isUnassignedPopulation()"
        [inputQuestionId]="inputQuestionId"
      >
      </app-form-field-wrapper>
      }
    </div>
    } @if (question.displayFieldType === 'table') {
    <div
      [hidden]="question.hidden && !showHiddenQuestions"
      class="table-q"
      id="{{ 'question-' + question.id }}"
    >
      <div class="table-label" (click)="selectField(question)">
        <div style="flex:1">
          <label>{{ question.question }}</label>
        </div>
        @if (config.featureFlags.updateTableByCSVFile) {
        <input
          type="file"
          class="list-upload-btn"
          (click)="$event.target.value = null"
          (change)="upload($event.target.files, question)"
        />
        } @if (config.featureFlags.updateTableByCSVFile) {
        <div class="actions">
          <div
            (click)="download(question)"
            class="ui primary background button tiny"
          >
            Download
          </div>
        </div>
        }
        <div>
          <div
            [hidden]="!question.rows || question.rows.length === 0"
            (click)="canEditClientRules() && setGlobal(question)"
            class="icon globe"
            [ngClass]="{
              disabled: !question?.isGlobal,
              'prevent-click': categoryRules?.id && question?.isGlobal
            }"
          ></div>
          <div class="ui inverted popup" *transloco="let t">
            {{
              question?.isGlobal
                ? t(
                    "clients.this-answer-is-global-across-all-populations-for-this-client"
                  )
                : t(
                    "clients.click-to-save-answer-to-all-populations-for-this-client"
                  )
            }}
          </div>
        </div>
      </div>
      <div
        class="table-group"
        [ngClass]="{
          disabled:
            (categoryRules?.id && hasGlobalAnswer(question)) ||
            (!categoryRules?.id && isUnassignedPopulation()) ||
            !hasCountryAccess
        }"
      >
        <div #tableCont class="table-container">
          <table #table cellpadding="0" cellspacing="0" class="sticky-header">
            <thead>
              <tr>
                <td (click)="newRow(question)" class="row-num">
                  <div class="add icon" title="Add New Row"></div>
                </td>
                @for (_question of question.questions; track _question) { @if
                (!_question.hidden && !showHiddenQuestions) {
                <td
                  title="{{
                    _question?.mandatory
                      ? 'This column is mandatory'
                      : undefined
                  }}"
                  [ngClass]="{
                    'checkbox-column': isBooleanCheckboxColumn(_question),
                    highlight: inputQuestionId === _question?.id
                  }"
                  (click)="selectField(_question)"
                >
                  @if (showQuestionId) {
                  <span>{{ _question?.id }}.</span>
                  } {{ _question?.question }}
                </td>
                } }
              </tr>
            </thead>
            <tbody>
              @for (rowAnswer of question.rows; track rowAnswer; let index =
              $index) {
              <tr>
                <td class="row-num" align="center">{{ index + 1 }}</td>
                @for (cell of getTableCells(index, question); track
                tableCellsTrackBy($index, cell)) {
                <td
                  title="Click to edit answer"
                  id="cell-{{ question.id }}-{{ cell.question?.id }}-{{
                    index
                  }}"
                  (click)="focusTableInput(question, cell, index)"
                  [ngClass]="{
                    active: cell.answer?.isActive,
                    'checkbox-column': isBooleanCheckboxColumn(cell.question),
                    error:
                      cell.question.mandatory &&
                      !cell.formControl?.value && !cell.answer.answer
                  }"
                >
                  @if (!cell.answer?.isActive) {
                  <div
                    class="answer"
                    [ngClass]="{
                      checkbox: isBooleanCheckboxColumn(cell.question)
                    }"
                  >
                    @if (!isBooleanCheckboxColumn(cell.question)) {
                    <div class="value">
                      {{ cell.question | answerDisplay: cell.displayAnswer }}
                    </div>
                    } @if (isBooleanCheckboxColumn(cell.question)) { @if
                    (cell.formControl? cell.formControl.value :
                    cell.answer.answer==='true') {
                    <div class="blue tick icon"></div>
                    } @if (cell.formControl? !cell.formControl.value :
                    cell.answer.answer !=='true') {
                    <div class="grey circle outline icon"></div>
                    } }
                    <div>
                      @if (!inspectMode &&
                      !isBooleanCheckboxColumn(cell.question)) {
                      <i class="pencil icon"></i>
                      }
                    </div>
                  </div>
                  } @if (cell.answer?.isActive) {
                  <div>
                    @if (cell.formControl) {
                    <app-form-field-wrapper
                      [formGroup]="formGroup"
                      [questions]="question?.questions"
                      [question]="cell.question"
                      [row]="index"
                    ></app-form-field-wrapper>
                    }
                  </div>
                  }
                </td>
                }
              </tr>
              }
            </tbody>
          </table>
        </div>
      </div>
    </div>
    } }
  </div>

  @if (showHintBox && (activeField?.clientHint || (activeField &&
  hasGlobalAnswer(activeField)))) {
  <div id="hints" cdkDrag cdkDragBoundary=".rules-boundary">
    <div id="hints-container" [@enterAnimation]>
      <div (click)="showHintBox = false" class="delete icon"></div>
      @if (!hasGlobalAnswer(activeField) || (!categoryRules?.id &&
      activeField.clientHint)) {
      <div>
        <strong>{{ "clients.hint" | transloco }}</strong>
        <p>{{ activeField.clientHint }}</p>
      </div>
      } @if (categoryRules?.id && hasGlobalAnswer(activeField)) {
      <p>
        {{
          "clients.this-field-can-only-be-edited-from-the-global-fields-menu"
            | transloco
        }}
      </p>
      }
    </div>
  </div>
  }
</div>

<!--- for later release --->
<!--<div #saveGlobalAnsModal-->
<!--id="save-global-ans-modal"-->
<!--class="ui tiny modal">-->

<!--<h2 style="margin:0">Please wait...</h2>-->

<!--<div class="content">-->

<!--<p>Rubix is calculating how many populations and tax returns your changes will impact. Once complete, you will have-->
<!--the opportunity to acknowledge the impact and save.</p>-->

<!--</div>-->

<!--<div id="loader-container">-->
<!--<div class="ui massive loader"></div>-->
<!--</div>-->

<!--</div>-->

<!--- for later release --->
<!--<div #confirmModal-->
<!--id="confirm-modal"-->
<!--class="ui tiny modal">-->

<!--<h2 style="margin:0">Are you sure?</h2>-->

<!--<div class="content">-->

<!--<p>By making this field a global field for this client, you will update the field across 6 populations, which will-->
<!--effect the calculations of:</p>-->

<!--<p>567 completed tax returns, <strong>download CSV list</strong><br/>-->
<!--344 in progress tax returns, <strong>download CSV list</strong>-->
<!--</p>-->

<!--<p>Please confirm you want to proceed with the change.</p>-->

<!--</div>-->

<!--<div class="actions">-->
<!--<div class="ui basic white deny button">No, cancel</div>-->
<!--<div class="ui primary approve button">Yes, confirm and save</div>-->
<!--</div>-->

<!--</div>-->

@if (!populationRules) {
<div class="ui active inverted dimmer">
  <div class="ui large text loader">{{ "clients.loading" | transloco }}</div>
</div>
}
